import {initialMarketplaceState} from "../../state/marketplace/marketplace.state";
import {EMarketplaceActions, MarketplaceActions} from "../../actions/marketplace/marketplace.actions";
import {emptyParty, IParty} from "@retail-data-factory/rdf-angular-types-api";

export const marketplaceReducers = (
  state = initialMarketplaceState,
    action: MarketplaceActions
) =>{
  switch (action.type) {
    case EMarketplaceActions.LoadSubscriptions:
      return state;
    case EMarketplaceActions.LoadSubscriptionsSuccess:
      const dataSourceProviders: Array<IParty> = [];
      action.payload.forEach(subscription=>{
        if (!dataSourceProviders.find(t=>t.id === subscription.service.ownerPartyId)) {
          dataSourceProviders.push({
            ...emptyParty,
            id: subscription.service.ownerPartyId,
            name: subscription.service.ownerPartyName,
            shortName:  subscription.service.ownerPartyShortName
          });
        }
      });

      return {
        ...state,
        subscriptions: action.payload,
        datasourceProviders: dataSourceProviders,
        isLoaded: true

      };
    case EMarketplaceActions.LoadSubscriptionsFailure:
      return {
        ...state,
        subscriptions: [],
        datasourceProviders: [],
        isLoaded: true
      };

    default:
      return state;

  }
};

